import styled from 'styled-components';

export default styled.footer`
  > footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;

    background: #48acde;

    padding: 0.8rem 3rem;

    > .copywrite {
      flex: 1 1 auto;

      font-size: 1.2rem;
      text-align: right;
      color: white;
    }
  }
`;
